import { lazy } from 'react'

import type { RouteObject } from 'react-router'

const SimuladorPage = lazy(() =>
  import('@/features/simulador/chile/pages/simulador').then((module) => ({ default: module.SimuladorPage })),
)

export const chileSimuladorRoutes: RouteObject[] = [
  {
    path: 'es-CL/simulador',
    children: [
      {
        index: true,
        element: <SimuladorPage />,
      },
    ],
  },
]
